export const iconFontAwesomeHumanitarianTruckFieldUn = (
	<i className="fa-solid fa-truck-field-un"></i>
);
